export const PAY = 'PAY'
export const EDIT = 'EDIT'
export const CHARGE_ONLY = 'CHARGE_ONLY'
export const CHARGE_AND_SAVE = 'CHARGE_AND_SAVE'
export const REUSE_CARD_ON_FILE = 'REUSE_CARD_ON_FILE'
export const SAVE_ONLY = 'SAVE_ONLY'
